import { stringFormat } from 'susy-common/stringUtils';
import { ILocalization, ServerErrors } from '../localization/definitions/types';
import { store } from '../store/store';

export const errorMessagesTranslationMapper = (
    errMessageCode: keyof ServerErrors,
    errMsgParams: string[] = []
) => {
    const localization: ILocalization = store.getState().localization;
    let translation =
        localization.localizationStrings.susy.serverErrors[errMessageCode];

    if (!translation) {
        return errMessageCode;
    }

    if (errMsgParams && errMsgParams.length > 0) {
        translation = stringFormat(translation, errMsgParams);
    }

    return translation;
};
